"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function IOLogoMedium(props) {
    let { width, height, size } = props;
    if (size !== undefined) {
        width = size;
        height = size;
    }
    if (width === undefined && height === undefined) {
        width = 16;
        height = 16;
    }
    return (react_1.default.createElement("svg", { className: "glx--icon glx-io-icon", width: width, height: height, xmlns: "http://www.w3.org/2000/svg", x: "0", y: "0", enableBackground: "new 0 0 512 512", viewBox: "0 0 512 512" },
        react_1.default.createElement("path", { d: "M28 28v456h456V28H28zm378.83 108.04l-24.46 23.45a7.162 7.162 0 00-2.72 6.86v172.28c-.44 2.61.61 5.26 2.72 6.86l23.88 23.45v5.15H286.13v-5.15l24.74-24.02c2.43-2.43 2.43-3.15 2.43-6.86V198.81l-68.79 174.71h-9.3l-80.09-174.71v117.1c-.67 4.92.97 9.88 4.43 13.44l32.18 39.03v5.15h-91.24v-5.15l32.18-39.03c3.44-3.57 4.98-8.56 4.15-13.44V180.5c.38-3.76-1.05-7.48-3.86-10.01l-28.6-34.46v-5.15h88.81l68.65 150.55 60.35-150.55h84.66v5.16z" })));
}
exports.default = IOLogoMedium;
